import { BONDS_STORE_NAME, ABS_ASSET_CLASS_ID } from '@/creditflowresearch/application/Bonds/constants';
import AsyncList from '@framework/ui/Organisms/Filters/FiltersPanel/AsyncList/AsyncList';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { getContainer } from '@framework/di/getContainer';
import BondsRepository from '@/creditflowresearch/infrastructure/repository/BondsRepository';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const IssuerListContainer = (props) => {
  const { getFiltersByFilterName } = useFiltersContext();
  const selectedValues = getFiltersByFilterName(BONDS_STORE_NAME, props.filterName);
  const { filtersPayload } = useBondsFiltersContext();
  const { currentAssetClass } = useBondsAssetClassesContext();
  const container = getContainer();
  const bondsRepository = container.get(BondsRepository);

  const getBondsIssuerList = (search) => bondsRepository.getBondsIssuersFilter(
      { ...filtersPayload, includedAssetClassId: currentAssetClass?.id || ABS_ASSET_CLASS_ID }, search);

  const optionsMapper = (option) => ({
    value: option.id,
    label: option.name,
    issuerTicker: option.issuerTicker,
  });

  return (
    <AsyncList
      { ...props }
      loadOptions={ getBondsIssuerList }
      selectedValues={ selectedValues || [] }
      optionsMapper={ optionsMapper }
    />
  );
};

export default IssuerListContainer;
